<template>
  <p class="db-funnel-loader db-text-center">
    <DbSpinner />
    <span class="db-bold db-funnel-loader-title db-title-4">
      <!-- @slot Title -->
      <slot name="title" />
    </span>
    <span class="db-funnel-loader-message">
      <!-- @slot Message  -->
      <slot name="message" />
    </span>
  </p>
</template>

<style scoped>
.db-app .db-funnel-loader {
  --db-height-min-funnel-loader: 70vh;
}

.db-app .db-funnel-loader {
  display: grid;
  place-content: center;
  justify-items: center;
  gap: var(--db-spacer-20);
  min-height: var(--db-height-min-funnel-loader);
  padding-block: var(--db-spacer-20);
}

.db-app .db-funnel-loader > * {
  max-width: remFix(27.5rem);
}

.db-app .db-funnel-loader :deep(.db-spinner) {
  margin-bottom: var(--db-spacer-12);
}

@media screen and (max-width: 991px) {
  .db-app .db-funnel-loader :deep(.db-spinner) {
    width: var(--db-spacer-64);
    height: var(--db-spacer-64);
  }
}
</style>
